import { BrandKitsNewContent } from "@/pages/BrandKitsNew";
import { withTour } from "@/components/withTour";
import { useTranslation } from "react-i18next";

const useTourSteps = () => {
  const { t } = useTranslation();
  return [
    {
      selector: '#brand-kit-name-input',
      content: t('brandKitsNew.tour.nameInput'),
      position: 'bottom',
    },
    {
      selector: '#brand-kit-preview',
      content: t('brandKitsNew.tour.preview'),
      position: 'right',
    },
    {
      selector: '#brand-kit-style-panel',
      content: t('brandKitsNew.tour.sidePanel'),
      position: 'left',
    },
    {
      selector: '#save-brand-kit-button',
      content: t('brandKitsNew.tour.saveButton'),
      position: 'bottom',
    },
  ];
};

const AdminBrandKitNewContent = () => {
  return <BrandKitsNewContent adminMode />;
};

const AdminBrandKitNewWrapper = () => {
  const tourSteps = useTourSteps();
  const AdminBrandKitNew = withTour(AdminBrandKitNewContent, 'autoclipper-admin-brand-kit-new-tour-seen', tourSteps);
  return <AdminBrandKitNew />;
};

export default AdminBrandKitNewWrapper;
